var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-container"},[_c('hi-header',{attrs:{"themeClass":_vm.themeClass,"theme":_vm.theme,"team":_vm.team}}),_c('div',{class:[_vm.teamClass, 'bg-' + _vm.themeClass, 'main-container']},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }